/**
 * DataTables 전역 기본값 ($j.F.Admin.TableConfig) — 관리자 표의 공통 규약.
 *
 * 생성자에서 **동기로** 잡는다: main.js 는 dataTables.min.js 뒤·페이지 인라인 스크립트(@yield('script'))
 * 앞에 실리므로(adm/layouts/main.blade.php), 표가 만들어지기 전에 기본값이 서 있어야 한다.
 * DataTable 이 없는 사이트(비관리자)에서는 가드에 걸려 아무 일도 하지 않는다.
 *
 * (구 public/js/admin.js 하단의 DataTable.defaults 블록)
 *
 *  1) 하단 건수 문구를 한글로 — 표마다 language 를 따로 주던 것을 여기로 모은다.
 *     페이지가 자기 language 를 주면 그 키만 덮어쓴다(DataTables 가 깊은 병합을 한다).
 *  2) 하단 배치 — 좌 건수 · 우 페이지번호. DataTables 2 기본값과 같지만 "우리 규약"임을 명시한다.
 *
 * ⚠ 상단(topStart/topEnd)은 건드리지 않는다. 화면마다 검색·필터 구성이 달라서다.
 */
export default class TableConfig {
    constructor() {
        if (!(window.DataTable && DataTable.defaults)) return;
        Object.assign(DataTable.defaults, {
            language: Object.assign({
                info:          '총 _TOTAL_건 중 _START_–_END_',
                infoEmpty:     '0건',
                infoFiltered:  '(전체 _MAX_건에서 검색)',
                lengthMenu:    '_MENU_개씩',
                search:        '검색:',
                zeroRecords:   '검색 결과가 없습니다.',
                emptyTable:    '데이터가 없습니다.',
                loadingRecords:'불러오는 중…',
                processing:    '처리 중…',
                paginate: { first: '처음', previous: '이전', next: '다음', last: '마지막' },
                aria: { orderable: ': 정렬', orderableReverse: ': 반대로 정렬' }
            }, DataTable.defaults.language || {})
        });
    }
}
